import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export const Legal = () => {
  return (
    <main className="bg-[#0A0A0A] text-white min-h-screen" data-testid="legal-page">
      {/* Mini header */}
      <div className="border-b border-white/10 bg-[#0A0A0A]/95 backdrop-blur sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link"><Logo /></Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-[#FFD600] uppercase tracking-wider"
          >
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </div>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 prose-invert">
        <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">— Informations légales</div>
        <h1 className="font-display text-4xl sm:text-5xl text-white uppercase tracking-tight mb-10">
          Mentions légales<br />& <span className="text-[#FFD600]">confidentialité</span>
        </h1>

        <Section title="Éditeur du site">
          <p><strong>MK Remorquage</strong> — entreprise individuelle</p>
          <p>2670 avenue Julien Panchot, 66000 Perpignan, France</p>
          <p>Téléphone : <a href="tel:+33620735220" className="text-[#FFD600]">06 20 73 52 20</a></p>
          <p>Email : <a href="mailto:mkremorquage66@gmail.com" className="text-[#FFD600]">mkremorquage66@gmail.com</a></p>
          <p className="text-neutral-400 text-sm">N° SIRET : 934 417 601 00010</p>
        </Section>

        <Section title="Hébergement">
          <p>
            Le site est hébergé sur l'infrastructure cloud Emergent.
            Pour toute question concernant l'hébergement, contacter l'éditeur.
          </p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus présents sur ce site (textes, photographies, logos, graphismes) est la
            propriété exclusive de MK Remorquage, sauf mention contraire. Toute reproduction sans autorisation
            préalable est interdite.
          </p>
        </Section>

        <Section title="Protection des données (RGPD)">
          <p>
            Le formulaire de contact collecte les données suivantes : nom, téléphone, email (facultatif), lieu
            de l'intervention, type de service, véhicule (facultatif), message (facultatif).
          </p>
          <p>
            Ces données sont utilisées <strong>uniquement</strong> pour vous recontacter dans le cadre de votre
            demande d'intervention. Elles ne sont ni revendues, ni cédées à des tiers.
          </p>
          <p>
            Conformément au RGPD et à la loi "Informatique et Libertés", vous disposez d'un droit d'accès, de
            rectification, de suppression et d'opposition concernant vos données. Pour exercer ces droits,
            contactez-nous à <a href="mailto:mkremorquage66@gmail.com" className="text-[#FFD600]">mkremorquage66@gmail.com</a>.
          </p>
          <p>
            Durée de conservation : les demandes de contact sont conservées 3 ans à compter du dernier échange,
            puis supprimées.
          </p>
        </Section>

        <Section title="Cookies">
          <p>
            Ce site n'utilise <strong>pas de cookies publicitaires</strong> ni de traceurs commerciaux. Seuls
            des cookies techniques strictement nécessaires au bon fonctionnement du site peuvent être utilisés.
          </p>
        </Section>

        <Section title="Responsabilité">
          <p>
            MK Remorquage met tout en œuvre pour fournir des informations exactes et à jour. Toutefois, en cas
            d'urgence routière, le téléphone reste le moyen le plus fiable et rapide :
            {" "}<a href="tel:+33620735220" className="text-[#FFD600] font-bold">06 20 73 52 20</a>.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Pour toute question relative au site, à vos données ou à nos services :
          </p>
          <p>
            <a href="mailto:mkremorquage66@gmail.com" className="text-[#FFD600]">mkremorquage66@gmail.com</a>
            <br />
            <a href="tel:+33620735220" className="text-[#FFD600]">06 20 73 52 20</a>
          </p>
        </Section>

        <p className="text-neutral-500 text-xs mt-12">
          Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
        </p>
      </article>

      <Footer />
    </main>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display text-2xl text-[#FFD600] uppercase tracking-tight mb-3">{title}</h2>
    <div className="space-y-3 text-neutral-300 leading-relaxed text-base">{children}</div>
  </section>
);

export default Legal;
